<template>
    <b-row>
        <b-col sm="6">
            <b-form-group
                label-cols-sm="4"
                :label="$t('createShipment.label.Description')"
                label-align-sm="left"
                :placeholder="'Choose description'"
            >
                <b-input-group size="sm">
                    <b-col sm="10">
                        <vSelect
                            :dynamicWidth="true"
                            :options="getListOfCustomerDescriptions"
                            :placeholder="$t('createShipment.placeholder.Choose Description')"
                            label="text"
                            name="descriptionDropdown"
                            class="description-dropdown"
                            @input="transferDescription"
                            v-model="selectedDescription"
                        />
                    </b-col>
                </b-input-group>
                <datalist id="descList">
                    <option>Components</option>
                    <option>Robot</option>
                </datalist>
            </b-form-group>
        </b-col>

        <b-col sm="6">
            <b-form-group
                label-cols-sm="4"
                :label="$t('createShipment.label.Description')"
                label-align-sm="left"
            >
                <b-input-group size="sm">
                    <b-col sm="10">
                        <b-form-input
                            size="sm"
                            type="text"
                            v-model="shipment.texts.description"
                            name="shipment.texts.description"
                            :class="{
                                'is-invalid': v.shipment.texts.description.$error
                            }"
                            aria-describedby="description-feedback"
                            @update="v.shipment.texts.description.$touch()"
                        />
                      
                        <b-form-invalid-feedback
                            id="description-feedback"
                            name="shipment.texts.description.error"
                            v-if="v.shipment.texts.description.$error"
                        >
                            <validationRequired
                                fieldName="createShipment.label.Description"
                                :fieldValid="v.shipment.texts.description.required"
                            />

                            <validationMaxLength
                                fieldName="createShipment.label.Description"
                                :fieldValid="v.shipment.texts.description.maxLength"
                                :fieldMax="v.shipment.texts.description.$params.maxLength.max"
                            />
                          <ValidationNotAllowedWord
                              fieldName="createShipment.label.Description"
                              :fieldValid="v.shipment.texts.description.onlyAllowedWords"
                          />
                        </b-form-invalid-feedback>
                    </b-col>
                    <b-input-group-append>
                        <div>
                            <requiredIcon
                                :active="hasShipmentOptions"
                                name="shipment.texts.descriptionRequiredIcon"
                            />
                        </div>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="6">
            <b-form-group
                label-cols-sm="4"
                :label="$t('createShipment.label.Save Description')"
                label-align-sm="left"
            >
                <b-input-group size="sm">
                    <b-col sm="10">
                        <b-form-checkbox
                            class="float-left"
                            size="sm"
                            name="saveDescriptionCheckbox"
                            v-model="shipment.saveFlags.saveDescription"
                        ></b-form-checkbox>
                    </b-col>
                </b-input-group>
            </b-form-group>
        </b-col>
      <b-col sm="6" v-if="display(fieldNames.ADDITIONAL_MESSAGE)">
        <b-form-group
            label-cols-sm="4"
            :label="$t('createShipment.label.AdditionalMessage')"
            label-align-sm="left"
        >
          <b-input-group size="sm">
            <b-col sm="10">
              <b-form-textarea
                  id="textarea"
                  v-model="shipment.texts.additionalMessage"
                  placeholder="..."
                  rows="2"
                  max-rows="6"
                  style="font-size: 12px; font-weight: 700"
              ></b-form-textarea>
            </b-col>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
</template>

<script>
import vSelect from './vSelect';
import 'vue-select/dist/vue-select.css';
import viewOptions from '../mixins/viewOptionsMixin';
import { ACTIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
import { FIELD_NAMES } from '../store/nameConstants';
import { mapState } from 'vuex';
import requiredIcon from './requiredIcon';
import validationMaxLength from './Validation/ValidationMaxLength';
import validationRequired from './Validation/ValidationRequired';
import { mapGetters } from 'vuex';
import resetMixin from '../mixins/resetMixin';
import ValidationNotAllowedWord from "@/components/Validation/ValidationNotAllowedWord";

export default {
    components: {
      ValidationNotAllowedWord,
        vSelect,
        requiredIcon,
        validationMaxLength,
        validationRequired
    },

    mixins: [resetMixin, viewOptions],

    props: {
        shipment: { required: true },
        v: { required: true }
    },

    data() {
        return {
            fieldNames: FIELD_NAMES,
            selectedDescription: null
        };
    },

    watch: {
        reset() {
            this.shipment.saveFlags.saveDescription = false;
            this.isSaveFlag = false;
            this.selectedDescription = null;
        }
    },

    computed: {
        ...mapGetters('createShipment', ['hasShipmentOptions', 'getListOfCustomerDescriptions'])
    },
    methods: {
        transferDescription: function(item) {
            this.shipment.texts.description = item.text;
        }
    }
};
</script>

<style>
textarea {
  font-family: 'Mulish', sans-serif;
  font-size: 8px;
}

.description-dropdown ul li {
    overflow: hidden;
    white-space: nowrap;
}
</style>
